import axios from 'axios'

const API_ENDPOINT = window.config.ssURL + 'helpful'

export default {
    all(params) {
        return axios.get(API_ENDPOINT, {params})
    },
}
